/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Scroll_Speed_LabelInputs */

const en_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll speed`)
};

const fr_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse de défilement`)
};

const de_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrollgeschwindigkeit`)
};

const it_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`velocità di scorrimento`)
};

const ru_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`скорость прокрутки`)
};

const es_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de desplazamiento`)
};

const zh_cn2_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动速度`)
};

const ja_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクロール速度`)
};

const hi_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रॉल गति`)
};

const pt_pt2_audio_recorder_scroll_speed_label = /** @type {(inputs: Audio_Recorder_Scroll_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade de rolagem`)
};

/**
* | output |
* | --- |
* | "Scroll speed" |
*
* @param {Audio_Recorder_Scroll_Speed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_scroll_speed_label = /** @type {((inputs?: Audio_Recorder_Scroll_Speed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Scroll_Speed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_scroll_speed_label(inputs)
	if (locale === "de") return de_audio_recorder_scroll_speed_label(inputs)
	if (locale === "it") return it_audio_recorder_scroll_speed_label(inputs)
	if (locale === "ru") return ru_audio_recorder_scroll_speed_label(inputs)
	if (locale === "es") return es_audio_recorder_scroll_speed_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_scroll_speed_label(inputs)
	if (locale === "ja") return ja_audio_recorder_scroll_speed_label(inputs)
	if (locale === "hi") return hi_audio_recorder_scroll_speed_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_scroll_speed_label(inputs)
	return en_audio_recorder_scroll_speed_label(inputs)
});